var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 152,
    viewBox: "0 0 154 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#A16374",
    strokeWidth: 11.25,
    d: "M141.82 130.81c-6.885 6.92-18.07 6.92-24.962 0L81.457 95.42l-35.304 35.33c-6.916 6.92-18.065 6.98-24.993.06-6.886-6.92-6.886-18.09.036-25.01l35.31-35.33L21.184 35.2c-6.922-6.92-6.88-18.09.012-24.95 6.904-6.92 18.04-6.98 24.957 0l35.328 35.27 35.352-35.33c6.917-6.92 18.065-6.92 24.957 0a17.594 17.594 0 010 24.95l-35.358 35.33 35.4 35.39c6.88 6.92 6.905 18.03-.012 24.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16374",
    fillRule: "nonzero",
    d: "M146.052 6.502l-.285-.289-.28-.277c-9.11-8.84-23.614-8.746-32.632.278L81.478 37.569 50.128 6.27c-9.076-9.16-23.792-9.135-32.914.008l-.284.288c-8.811 9.075-8.738 23.6.277 32.612L48.55 70.474l-31.331 31.35c-9.11 9.105-9.124 23.83-.046 32.953l.29.285c9.151 8.834 23.647 8.691 32.67-.337l31.326-31.35 31.423 31.413c9.082 9.12 23.842 9.12 32.927-.01l.284-.29c8.806-9.115 8.707-23.564-.27-32.593L114.388 70.47l31.378-31.351c9.016-9.03 9.115-23.486.286-32.617zm-8.248 7.658l.01.008c4.72 4.72 4.717 12.269-.004 16.997L98.475 70.47l39.38 39.37a11.998 11.998 0 01-.013 16.994 11.98 11.98 0 01-16.999.007L81.455 87.463l-39.28 39.31c-4.738 4.74-12.326 4.766-17.04.057-4.692-4.716-4.685-12.331.038-17.052l39.29-39.312L25.159 31.22c-4.706-4.704-4.694-12.305.005-16.982 4.742-4.753 12.3-4.766 16.993-.028l39.326 39.26L120.81 14.17c4.72-4.723 12.3-4.723 16.994-.01z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0ff04fd1.svg";
export { ForwardRef as ReactComponent };